import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'app-view-dialog',
    imports: [],
    templateUrl: './view-dialog.component.html',
    styleUrl: './view-dialog.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
// Component for viewing large texts dialog
export class ViewDialogComponent {
    text: string;
}
